import { render, staticRenderFns } from "./orgTypeTreePage.vue?vue&type=template&id=28ac3d1a&scoped=true&"
import script from "./orgTypeTreePage.vue?vue&type=script&lang=js&"
export * from "./orgTypeTreePage.vue?vue&type=script&lang=js&"
import style0 from "./orgTypeTreePage.vue?vue&type=style&index=0&id=28ac3d1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ac3d1a",
  null
  
)

export default component.exports